/**
 * Transformer for LitElement props which are of Object type and also mapped to attributes
 *
 * Will parse a stringified JSON attribute value for use as a prop and vice versa
 */
export const objectPropParser = {
    fromAttribute: <T = object>(value: string | T): T => {
        let result: T = <T>value;
        try {
            result = typeof value === 'object' ? value : JSON.parse(<string>value);
        } catch (x) {
            // eslint-disable-next-line no-console
            console.warn(`Could not JSON.parse value`, value);
        }
        return result;
    },
    toAttribute: (prop: string | object): string => {
        return typeof prop === 'object' && prop ? JSON.stringify(prop) : <string>prop;
    }
};

export default objectPropParser;